<template>
<div>
	<div class="bus-youshi">
		<div class="bus-youshi-title">合作优势</div>
		<div class="bus-youshi-desc">选择我们，享受无与伦比的合作优势</div>
		<div class="bus-youshi-list">
			<div class="bus-youshi-list-item">
				<div class="bus-youshi-list-item-title">
					<div class="bus-youshi-list-item-title-text">技术创新，领先行业</div>
				</div>
				<img src="../../assets/icon_youshi01.png" class="bus-youshi-list-item-img"/>
				<div class="bus-youshi-list-item-desc">
					我们通过结合先进的人工智能技术和大数据分析，为企业提供全流程招聘管理系统，从简历筛选到薪资发放，系统自动化处理所有环节，极大提升招聘效率。AI智能识别和自动化匹配功能确保每一位候选人都与岗位需求高度契合，从而提升招聘质量，减少招聘成本
				</div>
			</div>
			<div class="bus-youshi-list-item bus-ml20">
				<div class="bus-youshi-list-item-title" style="background: linear-gradient( 180deg, #DCFFED 0%, rgba(244,247,250,0) 100%);">
					<div class="bus-youshi-list-item-title-text">多渠道全方位曝光</div>
				</div>
				<img src="../../assets/icon_youshi02.png" class="bus-youshi-list-item-img"/>
				<div class="bus-youshi-list-item-desc">
					我们的招聘平台不仅支持传统的网页端，还整合了微信、抖音、支付宝、快手等多个主流小程序平台，为您的招聘岗位提供多渠道曝光。无论候选人活跃在哪个平台，我们都能触及到他们，最大化提升岗位曝光度，快速吸引更多优质候选人
				</div>
			</div>
			<div class="bus-youshi-list-item bus-ml20">
				<div class="bus-youshi-list-item-title" style="background: linear-gradient( 180deg, #DCF5FF 0%, rgba(244,247,250,0) 100%);">
					<div class="bus-youshi-list-item-title-text">强大的行业背景和经验积累</div>
				</div>
				<img src="../../assets/icon_youshi03.png" class="bus-youshi-list-item-img"/>
				<div class="bus-youshi-list-item-desc">
					我们深耕招聘行业多年，积累了丰富的行业经验，并拥有强大的资源支持。我们了解各行各业的需求，能够为您提供精准、高效的招聘解决方案。无论您是大中型企业，还是初创公司，我们都能根据您的需求定制专属方案
				</div>
			</div>
			<div class="bus-youshi-list-item bus-ml20">
				<div class="bus-youshi-list-item-title" style="background: linear-gradient( 180deg, #DCFFED 0%, rgba(244,247,250,0) 100%);">
					<div class="bus-youshi-list-item-title-text">精准数据支持，智能决策分析</div>
				</div>
				<img src="../../assets/icon_youshi04.png" class="bus-youshi-list-item-img"/>
				<div class="bus-youshi-list-item-desc">
					我们的系统不仅仅是招聘工具，更是一个智能化的决策平台。通过实时数据追踪与分析，您可以随时了解招聘进度、效果反馈，帮助您做出更加精准的招聘决策。这种数据驱动的方式，不仅提高了招聘效率，也帮助企业优化用人结构，提升整体团队质量
				</div>
			</div>
			<div class="bus-youshi-list-item bus-ml20">
				<div class="bus-youshi-list-item-title">
					<div class="bus-youshi-list-item-title-text">快速响应，服务无忧</div>
				</div>
				<img src="../../assets/icon_youshi05.png" class="bus-youshi-list-item-img"/>
				<div class="bus-youshi-list-item-desc">
					从合作初期到项目交付，我们的专业团队将为您提供全程的服务支持。我们有专门的技术团队，随时为您解答任何问题，确保您的需求能够得到及时响应和满足。我们的目标是与您共同成长，实现长期稳定的合作。
				</div>
			</div>
		</div>
	</div>
	<div class="bus-hezuo">
		<div class="bus-hezuo-title">
			合作模式
		</div>
		<div class="bus-hezuo-desc">
			灵活多样的合作模式，满足您的多元化需求
		</div>
		<div class="mt20">
			<div class="hezuo-flex">
				<div class="bus-hezuo-item">
					<img src="../../assets/icon_jishu.png" class="bus-hezuo-item-img"/>
					<div class="textL">
						<div class="bus-hezuo-item-title">
							技术合作
						</div>
						<div class="bus-hezuo-item-desc">
							我们提供灵活的技术对接方式，助力企业优化招聘系统，实现高效协作。无论是API接口集成，还是独立系统搭建，我们都能为您提供完善的技术支持，确保系统无缝对接，提升运营效率
						</div>
					</div>
					<img src="../../assets/pic_zhuangshi.png" class="bus-hezuo-item-icon" alt="" />
				</div>
				<div class="bus-hezuo-item bus-ml20">
					<img src="../../assets/icon_pingtai.png" class="bus-hezuo-item-img" />
					<div class="textL">
						<div class="bus-hezuo-item-title">平台合作</div>
						<div class="bus-hezuo-item-desc">
							如果您运营的是招聘平台或人力资源服务平台，我们欢迎与您展开深度合作。通过平台合作，我们共同拓展市场，整合资源，提升平台的用户体验和市场竞争力，实现互利共赢。
						</div>
					</div>
					<img src="../../assets/pic_zhuangshi.png" class="bus-hezuo-item-icon" alt="" />
				</div>
			</div>
			<div class="hezuo-flex mt20">
				<div class="bus-hezuo-item">
					<img src="../../assets/icon_qudao.png" class="bus-hezuo-item-img"/>
					<div>
						<div class="bus-hezuo-item-title">
							渠道合作
						</div>
						<div class="bus-hezuo-item-desc">
							我们的合作不仅仅限于传统的招聘服务，我们还通过多个社交平台和小程序渠道，让招聘岗位在微信、抖音、支付宝、快手等主流平台上进行多渠道曝光。通过这些平台的强大流量，我们帮助您最大化提高企业品牌的影响力和岗位曝光度。
						</div>
					</div>
					<img src="../../assets/pic_zhuangshi.png" alt="" class="bus-hezuo-item-icon" />
				</div>
				<div class="bus-hezuo-item bus-ml20">
					<img src="../../assets/icon_dingzhihua.png" class="bus-hezuo-item-img"/>
					<div>
						<div class="bus-hezuo-item-title">定制化合作</div>
						<div class="bus-hezuo-item-desc">
							针对不同企业的需求，我们提供完全定制化的解决方案。从招聘渠道的选择到岗位的定制化发布，我们都能根据您的要求量身打造适合您的招聘方案，确保合作效果最大化。
						</div>
					</div>
					<img src="../../assets/pic_zhuangshi.png" class="bus-hezuo-item-icon" alt="" />
				</div>
			</div>
		</div>
	</div>
	<div class="bus-flow">
		<div class="bus-flow-title">
			合作流程
		</div>
		<div class="bus-flow-desc">
			我们为您设计了简便高效的合作流程，让合作从开始到结束都能顺利进行，确保每一个环节都快速、高效。
		</div>
		<div class="bus-flow-flex mt30">
			<div class="bus-flow-line">
				<div class="bus-flow-line-item">
					<div class="bus-flow-line-icon"></div>
				</div>
				<div class="bus-flow-line-line"></div>
			</div>
			<div class="bus-flow-line">
				<div class="bus-flow-line-item">
					<div class="bus-flow-line-icon" ></div>
				</div>
				<div class="bus-flow-line-line"></div>
			</div>
			<div class="bus-flow-line">
				<div class="bus-flow-line-item">
					<div class="bus-flow-line-icon" ></div>
				</div>
				<div class="bus-flow-line-line"></div>
			</div>
			<div class="bus-flow-line">
				<div class="bus-flow-line-item">
					<div class="bus-flow-line-icon" ></div>
				</div>
				<div class="bus-flow-line-line"></div>
			</div>
			<div class="bus-flow-line">
				<div class="bus-flow-line-item">
					<div class="bus-flow-line-icon" ></div>
				</div>
				<div class="bus-flow-line-line"></div>
			</div>
		</div>
		<div class="bus-flow-item-con">
			<div class="bus-flow-item-list">
				<div class="display-flex">
					<img src="../../assets/icon_qiatan.png" class="flow-item-icon"/>
					<div class="flow-item-title">
						初步洽谈与需求沟通
					</div>
				</div>
				<div class="flow-item-desc">
					与我们的商务团队进行初步沟通，了解您的合作需求和目标，我们将根据您的需求提供专业的合作建议。
				</div>
			</div>
			<div class="bus-flow-item-list" >
				<div class="display-flex">
					<img src="../../assets/icon_fenxi.png" class="flow-item-icon"/>
					<div class="flow-item-title">
						深入需求分析与定制方案
					</div>
				</div>
				<div class="flow-item-desc">
					我们将与您深入探讨合作细节，分析您的具体需求，为您定制合适的合作方案，确保方案的精准匹配。
				</div>
			</div>
			<div class="bus-flow-item-list">
				<div class="display-flex">
					<img src="../../assets/icon_xieyi.png" class="flow-item-icon"/>
					<div class="flow-item-title">
						合作协议签署
					</div>
				</div>
				<div class="flow-item-desc">
					双方达成共识后，我们将签署正式的合作协议，明确各自的责任和义务，确保合作的顺利推进。
				</div>
			</div>
			<div class="bus-flow-item-list">
				<div class="display-flex">
					<img src="../../assets/icon_xiangmu.png" class="flow-item-icon"/>
					<div class="flow-item-title">
						启动合作与项目实施
					</div>
				</div>
				<div class="flow-item-desc">
					在协议签署后，我们将根据方案进行项目实施，提供全程技术支持和专业指导，确保每个环节顺利开展
				</div>
			</div>
			<div  class="bus-flow-item-list">
				<div class="display-flex">
					<img src="../../assets/icon_genjin.png" class="flow-item-icon"/>
					<div class="flow-item-title">
						后期跟进与优化
					</div>
				</div>
				<div class="flow-item-desc">
					合作过程中，我们将定期进行回访与数据分析，为您提供持续的服务支持，并根据您的反馈进行系统优化和功能提升。
				</div>
			</div>
		</div>
	</div>
	<div class="bus-case">
		<div class="case-list">
			<div class="case-title">
				合作案例
			</div>
			<div class="case-desc">
				我们与多家行业领先企业携手合作，通过定制化的招聘解决方案，帮助他们优化招聘流程、提高效率、降低成本，并在实际操作中取得了显著成果。以下是部分成功合作的详细案例，展示了我们的产品如何在实际环境中发挥出色效果。
			</div>
			<div class="case-item">
				<div class="case-item-box">
					<span class="case-item-box-num">01</span>
					<div class="case-item-box-title">公司A</div>
					<div class="case-item-box-desc">
						招聘系统升级与自动化流程引入
					</div>
				</div>
				<div class="case-item-box bus-ml20">
					<span class="case-item-box-num">02</span>
					<div class="case-item-box-title">公司B</div>
					<div class="case-item-box-desc">
						跨平台曝光与招聘效果提升
					</div>
				</div>
			</div>
			<div class="case-item-con">
				<div class="case-item-con-box">
					<div class="case-item-con-box-title">
						背景
					</div>
					<div class="case-item-con-box-desc">
						公司A是一家快速发展的科技公司，原有的招聘流程存在人工操作繁琐、筛选效率低、招聘周期长的问题，导致其在人才引进方面频繁面临挑战。公司希望通过引入自动化系统来提升招聘效率，减少人工干预，确保招聘质量。
					</div>
					<div class="case-item-con-box-list">
						合作方案
					</div>
					<div class="case-item-con-box-desc">
						招聘系统升级：我们为企业A定制了一款智能招聘管理平台，集成简历筛选、面试安排、面试反馈等功能，实现招聘全过程的自动化管理。<br><br> 智能简历筛选与匹配：结合AI算法，系统自动筛选符合岗位要求的简历，并根据候选人的专业背景、经验以及岗位要求进行精准匹配。<br><br> 面试流程优化：系统自动根据招聘需求安排面试，确保面试进度的透明与高效，招聘顾问可以实时查看面试安排和候选人反馈。
					</div>
					<div class="case-item-con-box-list">
						成果与反馈
					</div>
					<div class="case-item-con-box-desc">
						招聘周期缩短了40%：通过自动化简历筛选和面试安排，企业A大幅缩短了招聘周期，招聘职位的平均填补时间从原来的60天减少至35天。<br><br> 人才匹配度提升30%：通过智能化匹配算法，候选人与岗位的匹配度显著提高，企业A成功吸引了更多符合岗位要求的优质人才。<br><br> 招聘成本降低了25%：自动化流程的引入减少了招聘顾问的人力投入，节省了大量招聘成本。
					</div>
					<div class="case-item-bottom">
						<div class="case-item-con-box-quote">
							“与贵公司合作后，我们的招聘流程变得更加高效和精准。系统自动化的处理不仅减轻了招聘团队的工作压力，还提高了招聘效率。我们非常满意，并期待未来的进一步合作。”
						</div>
						<div class="case-item-con-box-quote-desc">
							—— 招聘负责人
						</div>
					</div>
				</div>
				<div class="case-item-con-box-one">
					<div class="case-item-con-box-title">
						背景
					</div>
					<div class="case-item-con-box-desc">
						企业B是一家零售行业的知名品牌，在全国范围内有大量门店，招聘需求巨大。原有的招聘信息主要通过传统的招聘网站进行发布，虽然覆盖了大量求职者，但由于信息发布渠道单一，岗位曝光度不够，导致招聘效果不理想。
					</div>
					<div class="case-item-con-box-list">
						合作方案
					</div>
					<div class="case-item-con-box-desc">
						多平台小程序合作：通过与我们的平台合作，企业B将其招聘信息同步发布到微信、抖音、支付宝、快手等多个平台，确保岗位信息能够精准触达更多潜在候选人。<br><br> 精准岗位推送与社交互动：通过微信和抖音等社交平台，岗位信息不仅能直接推送给感兴趣的用户，还能通过社交分享扩大传播范围。<br><br> 个性化招聘广告：在平台上发布互动性强的招聘广告，利用短视频和直播等形式，提高岗位的吸引力，增强求职者的参与感。
					</div>
					<div class="case-item-con-box-list">
						成果与反馈
					</div>
					<div class="case-item-con-box-desc">
						岗位曝光量提升了50%：通过多渠道同步发布，岗位信息在不同平台间得到了广泛传播，招聘岗位的曝光量显著提升，求职者的关注度大幅增加。<br><br> 招聘效率提高35%：通过精准的渠道推送和社交平台互动，企业B能够在短时间内接收到更多的合格候选人简历，招聘周期缩短，招聘效率明显提高。<br><br> 招聘成本降低了30%：通过线上平台的多平台曝光，企业B减少了传统招聘方式的广告费用与招聘中介成本，大大节省了招聘预算。
					</div>
					<div class="case-item-bottom">
						<div class="case-item-con-box-quote">
							“贵公司的平台帮助我们在多个社交渠道获得了更多的候选人关注，尤其是在年轻群体中的效果非常明显。我们能够在最短的时间内找到合适的候选人，提升了招聘的效率和质量，非常高兴与您合作。”
						</div>
						<div class="case-item-con-box-quote-desc">
							—— 招聘经理
						</div>
					</div>

				</div>
			</div>
			<div class="case-item-list">
				<div class="case-item-box">
					<span class="case-item-box-num">01</span>
					<div class="case-item-box-title">公司A</div>
					<div class="case-item-box-desc">
						招聘系统升级与自动化流程引入
					</div>
				</div>
				<div class="case-item-con-box">
					<div class="case-item-con-box-title">
						背景
					</div>
					<div class="case-item-con-box-desc">
						公司A是一家快速发展的科技公司，原有的招聘流程存在人工操作繁琐、筛选效率低、招聘周期长的问题，导致其在人才引进方面频繁面临挑战。公司希望通过引入自动化系统来提升招聘效率，减少人工干预，确保招聘质量。
					</div>
					<div class="case-item-con-box-list">
						合作方案
					</div>
					<div class="case-item-con-box-desc">
						招聘系统升级：我们为企业A定制了一款智能招聘管理平台，集成简历筛选、面试安排、面试反馈等功能，实现招聘全过程的自动化管理。<br><br> 智能简历筛选与匹配：结合AI算法，系统自动筛选符合岗位要求的简历，并根据候选人的专业背景、经验以及岗位要求进行精准匹配。<br><br> 面试流程优化：系统自动根据招聘需求安排面试，确保面试进度的透明与高效，招聘顾问可以实时查看面试安排和候选人反馈。
					</div>
					<div class="case-item-con-box-list">
						成果与反馈
					</div>
					<div class="case-item-con-box-desc">
						招聘周期缩短了40%：通过自动化简历筛选和面试安排，企业A大幅缩短了招聘周期，招聘职位的平均填补时间从原来的60天减少至35天。<br><br> 人才匹配度提升30%：通过智能化匹配算法，候选人与岗位的匹配度显著提高，企业A成功吸引了更多符合岗位要求的优质人才。<br><br> 招聘成本降低了25%：自动化流程的引入减少了招聘顾问的人力投入，节省了大量招聘成本。
					</div>
					<div class="case-item-con-box-quote">
						“与贵公司合作后，我们的招聘流程变得更加高效和精准。系统自动化的处理不仅减轻了招聘团队的工作压力，还提高了招聘效率。我们非常满意，并期待未来的进一步合作。”
					</div>
					<div class="case-item-con-box-quote-desc">
						—— 招聘负责人
					</div>
				</div>
				<div class="case-item-box bus-ml20">
					<span class="case-item-box-num">02</span>
					<div class="case-item-box-title">公司B</div>
					<div class="case-item-box-desc">
						跨平台曝光与招聘效果提升
					</div>
				</div>
				<div class="case-item-con-box-one">
					<div class="case-item-con-box-title">
						背景
					</div>
					<div class="case-item-con-box-desc">
						企业B是一家零售行业的知名品牌，在全国范围内有大量门店，招聘需求巨大。原有的招聘信息主要通过传统的招聘网站进行发布，虽然覆盖了大量求职者，但由于信息发布渠道单一，岗位曝光度不够，导致招聘效果不理想。
					</div>
					<div class="case-item-con-box-list">
						合作方案
					</div>
					<div class="case-item-con-box-desc">
						多平台小程序合作：通过与我们的平台合作，企业B将其招聘信息同步发布到微信、抖音、支付宝、快手等多个平台，确保岗位信息能够精准触达更多潜在候选人。<br><br> 精准岗位推送与社交互动：通过微信和抖音等社交平台，岗位信息不仅能直接推送给感兴趣的用户，还能通过社交分享扩大传播范围。<br><br> 个性化招聘广告：在平台上发布互动性强的招聘广告，利用短视频和直播等形式，提高岗位的吸引力，增强求职者的参与感。
					</div>
					<div class="case-item-con-box-list">
						成果与反馈
					</div>
					<div class="case-item-con-box-desc">
						岗位曝光量提升了50%：通过多渠道同步发布，岗位信息在不同平台间得到了广泛传播，招聘岗位的曝光量显著提升，求职者的关注度大幅增加。<br><br> 招聘效率提高35%：通过精准的渠道推送和社交平台互动，企业B能够在短时间内接收到更多的合格候选人简历，招聘周期缩短，招聘效率明显提高。<br><br> 招聘成本降低了30%：通过线上平台的多平台曝光，企业B减少了传统招聘方式的广告费用与招聘中介成本，大大节省了招聘预算。
					</div>
					<div class="case-item-con-box-quote">
						“与贵公司合作后，我们的招聘流程变得更加高效和精准。系统自动化的处理不仅减轻了招聘团队的工作压力，还提高了招聘效率。我们非常满意，并期待未来的进一步合作。”
					</div>
					<div class="case-item-con-box-quote-desc">
						 —— 招聘经理
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>

export default {
		name: 'bus',
		props: {
			showPop:false
	},
	data() {
		return {
			list:[{'title':'一、参与对象','desc':'在 辉煌达直聘 小程序中授权登录且已完成实名认证的用户视为符合参与活动资格，反之则为不符合。'},
				{'title':'二、活动介绍','desc':'邀请入职奖励活动是由 辉煌达企业 推出的，通过邀请好友报名并入职，好友成功入职并满足质保期后，邀请人即可获得对应岗位的奖励金。活动通过口碑传播推荐优质岗位，不仅让您与好友共同受益，还能扩展您的人脉网络，轻松赚取丰厚收益！'},
				{'title':'三、经纪人说明','desc':'什么是经纪人？<br>经纪人不仅可以参与邀请好友入职获得奖励，还能享受团队内所有成员产生收益的一定比例作为额外奖励金。<br><br>经纪人的收益来源<br>直接收益：通过个人邀请的好友成功入职并满足质保期后，获得对应岗位奖励金。<br>团队收益：团队成员邀请好友成功入职并满足质保期后，经纪人可获得额外奖励金（比例以平台规则为准）。<br><br>如何成为经纪人？<br>用户注册登录 辉煌达企业 小程序即可成为经纪人，并享受邀请好友入职奖励'},
				{'title':'四、领奖资格','desc':'好友通过您的邀请成功入职，并满足岗位对应的质保期后，推荐人即可获得该岗位设定的奖励金。<br>经纪人的团队奖励将在团队成员产生收益后同步发放至经纪人账户。<br>奖励金可随时提现，目前仅支持提现至绑定的银行卡账户。'},
				{'title':'五、奖励规则','desc':'岗位奖励：每个岗位对应的奖励金额不同，具体金额请以小程序内岗位页面显示为准。<br>团队奖励：经纪人可享受团队成员收益的额外奖励，比例根据平台规则设定。<br>动态调整：奖励金额可能根据岗位需求实时调整，默认只高不低，请以实际活动页面显示为准。<br>特别奖励：在特定活动期间，部分岗位或团队收益可能提供额外奖励金，详情请关注活动公告。'},
				{'title':'六、参与步骤','desc':'进入 辉煌达企业 小程序，点击首页岗位的“分析岗位”按钮，获取专属推荐链接或二维码海报。<br>将链接或海报分享给好友，好友通过链接或扫描二维码接受邀请并报名。<br>好友完成入职并满足质保期后，您即可获得该岗位对应的奖励金；若您是经纪人，还可获得团队收益奖励。'},
				{'title':'七、特别说明','desc':'用户需详细阅读并同意遵守本活动规则后方可参与，活动规则未尽事宜以 辉煌达企业 平台《用户协议》及相关规则为准。<br>若用户存在违规行为（包括但不限于虚假交易、作弊等），平台有权取消参与资格并追回已发放奖励。<br>活动奖励金额及规则可能根据实际业务需求调整，具体调整将通过活动页面公示。<br>如因不可抗力或其他特殊情况需调整或暂停活动，平台将依法依规进行公示并说明。<br>活动时间及规则的最终解释权归 辉煌达企业 平台所有。'},
				{'title':'八、联系客服','desc':'如有任何疑问，请通过小程序内的官方客服咨询，我们将为您提供详细解答。<br>成为经纪人，拓展团队收益，快来参与 辉煌达企业 邀请入职奖励活动吧！'},
			],
		};
	},
	created() {
	  
	},
	methods: {
		showPop(){
			this.$emit('pop',true);
		},
	}
}
</script>

<style scoped>
@import './index.css';
</style>
